import {
  GET_ONE_ESIGNATURE,
} from '../types'

const INITIAL_STATE = {
  oneEsignature: [],
}

const eSignatureReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ONE_ESIGNATURE:
      return {
        ...state,
        oneEsignature: payload.data,
      }
    
    default:
      return state
  }
}

export default eSignatureReducer
